"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bcmKunrenReducer = exports.bcmKunrenActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Kunren';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_MEDPLAN_ENTRY: PREFIX + 'SetEntry',
  SET_MEDPLAN_ENTRIES: PREFIX + 'SetEntries',
  SET_MEDPLAN_ERR_MSG: PREFIX + 'SetMedplanErrMsg',
  RESET_MEDPLAN_ERR_MSG: PREFIX + 'ResetMedplanErrMsg',
  SET_GUIDANCE_ENTRY: PREFIX + 'SetGuidanceEntry',
  SET_GUIDANCE_ENTRIES: PREFIX + 'SetGuidanceEntries',
  CHANGE_SCENARIO: PREFIX + 'ChangeScenario',
  SET_GUIDANCE_ERR_MSG: PREFIX + 'SetGuidanceErrMsg',
  RESET_GUIDANCE_ERR_MSG: PREFIX + 'ResetGuidanceErrMsg',
  SET_REPORT_ENTRY: PREFIX + 'SetReportEntry',
  SET_REPORT_ENTRIES: PREFIX + 'SetReportEntries',
  SET_PREVIOUS_REPORT_ENTRIES: PREFIX + 'SetPreviousReportEntries',
  SET_REPORT_ERR_MSG: PREFIX + 'SetReportErrMsg',
  RESET_REPORT_ERR_MSG: PREFIX + 'ResetReportErrMsg',
  SET_CONTENT: PREFIX + 'SetContent',
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  COPY_SEARCH_CONDITION: PREFIX + 'CopySearchCondtion',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  CHANGE_PAGE: PREFIX + 'ChangePage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  GO_MAIN: PREFIX + 'GoMain',
  GO_REGISTER: PREFIX + 'GoRegister',
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  RESET_PAGING: PREFIX + 'ResetPaging',
  UPDATE_FILE: PREFIX + 'UpdateFile',
  CLEAR: PREFIX + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  REPORT_ENTRY: 'report_entry',
  REPORT_ENTRY_RESULT: 'report_entry_result',
  REPORT_DELETE_RESULT: 'report_delete_result',
  MEDPLAN_ENTRY: 'medplan_entry',
  MEDPLAN_RESULT: 'medplan_result',
  GUIDANCE_ENTRY: 'guidance_entry',
  GUIDANCE_RESULT: 'guidance_result',
  GUIDANCE_DELETE: 'guidance_delete'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  kunrenInfo: {},
  doSearch: false,
  init: false,
  // ドキュメント管理（訓練）用
  searchConditions: {
    targetList: [],
    targetCd: '',
    kunrenNm: '',
    kaishaCd: '',
    soshikiCd: '',
    kaishasoshikiLabel: '',
    bcmKaishaSoshikiCd: ''
  },
  previousConditions: {
    targetList: [],
    targetCd: '',
    kunrenNm: '',
    kaishasoshikiLabel: '',
    bcmKaishaSoshikiCd: ''
  },
  searchResult: [],
  showAll: false,
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  // 訓練中期計画登録用
  entries: {
    scenarioPolicyCd: '',
    exercisesDt: '',
    riskDetailNotes: '',
    exercisesNm: '',
    kunrenPurpose: '',
    kunrenContent: '',
    supplement: '',
    partcipant: '',
    kunrenResult: '',
    kunrenEvaluation: '',
    hqComments: '',
    checkStatusList: [],
    fileList: [],
    repTaskList: [],
    reportResultList: [],
    medPlanList: [],
    th1Items: [],
    th2Items: []
  },
  medplanErrMsg: {
    tgtRiskErr: ''
  },
  // 実施要領・シナリオ登録用
  guidanceEntry: {
    documentKindCd: '',
    scenarioPolicyCd: '',
    scenarioNecFlg: false,
    exercisesDt: '',
    riskDetailNotes: '',
    kunrenPurpose: '',
    kunrenContent: '',
    supplement: '',
    regNecScenarioCheck: false,
    regBuScenarioCheck: false,
    checkStatusList: [],
    kunrenProgressCd: '',
    scenarioDisplayFlg: false
  },
  previousGuidanceEntry: {
    documentKindCd: '',
    scenarioPolicyCd: '',
    scenarioNecFlg: false,
    exercisesDt: '',
    riskDetailNotes: '',
    kunrenPurpose: '',
    kunrenContent: '',
    supplement: '',
    regNecScenarioCheck: false,
    regBuScenarioCheck: false,
    checkStatusList: [],
    kunrenProgressCd: '',
    scenarioDisplayFlg: false
  },
  guidanceErrMsg: {
    tgtRiskErr: ''
  },
  // 訓練実施報告用
  reportEntry: {
    documentKindCd: '',
    scenarioPolicyCd: '',
    exercisesDt: '',
    riskDetailNotes: '',
    exercisesNm: '',
    kunrenPurpose: '',
    kunrenContent: '',
    supplement: '',
    partcipant: '',
    kunrenResult: '',
    kunrenEvaluation: '',
    hqComments: '',
    checkStatusList: [],
    fileList: [],
    repTaskList: [],
    reportResultList: [],
    reportResultAverage: {
      resultNo: 0,
      teamName: '',
      replyNum: '',
      understand: 0,
      effect: 0,
      teamComment: ''
    },
    reportResultPrevious: {
      resultNo: 0,
      teamName: '',
      replyNum: '',
      understand: 0,
      effect: 0,
      teamComment: ''
    },
    krPrgCd: ''
  },
  previousReportEntry: {
    documentKindCd: '',
    scenarioPolicyCd: '',
    exercisesDt: '',
    riskDetailNotes: '',
    exercisesNm: '',
    kunrenPurpose: '',
    kunrenContent: '',
    supplement: '',
    partcipant: '',
    kunrenResult: '',
    kunrenEvaluation: '',
    hqComments: '',
    checkStatusList: [],
    fileList: [],
    repTaskList: [],
    reportResultList: [],
    reportResultAverage: {
      resultNo: 0,
      teamName: '',
      replyNum: '',
      understand: 0,
      effect: 0,
      teamComment: ''
    },
    reportResultPrevious: {
      resultNo: 0,
      teamName: '',
      replyNum: '',
      understand: 0,
      effect: 0,
      teamComment: ''
    },
    krPrgCd: ''
  },
  reportErrMsg: {
    tgtRiskErr: ''
  }
};

/**
 * アクション定義
 */
const bcmKunrenActions = exports.bcmKunrenActions = (0, _reduxActions.createActions)({
  // ドキュメント管理（訓練）用
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.COPY_SEARCH_CONDITION]: function () {
    return {
      searchConditions: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.UPDATE_FILE]: function () {
    return {
      fileInfo: arguments.length <= 0 ? undefined : arguments[0],
      data: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 訓練中期計画登録用
  [TYPES.SET_MEDPLAN_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_MEDPLAN_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_MEDPLAN_ERR_MSG]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 実施要領・シナリオ登録用
  [TYPES.SET_GUIDANCE_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_GUIDANCE_ENTRIES]: function () {
    return {
      guidanceEntry: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCENARIO]: function () {
    return {
      guidanceEntry: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_GUIDANCE_ERR_MSG]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 訓練実施報告用
  [TYPES.SET_REPORT_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_REPORT_ENTRIES]: function () {
    return {
      reportEntry: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_PREVIOUS_REPORT_ENTRIES]: function () {
    return {
      previousReportEntry: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_REPORT_ERR_MSG]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 共通使用
  [TYPES.GO_MAIN]: function () {
    return {
      doSearch: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_REGISTER]: function () {
    return {
      kunrenInfo: arguments.length <= 0 ? undefined : arguments[0],
      content: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_MEDPLAN_ERR_MSG, TYPES.RESET_GUIDANCE_ERR_MSG, TYPES.RESET_REPORT_ERR_MSG, TYPES.RESET_PAGING, TYPES.CLEAR);

/**
 * Reducer定義
 */
const bcmKunrenReducer = exports.bcmKunrenReducer = (0, _reduxActions.handleActions)({
  // ドキュメント管理（訓練）用
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.COPY_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    previousConditions: action.payload.searchConditions,
    init: true
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: action.payload.searchResult,
      doSearch: false
    });
  },
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      scrollTop: action.payload.scrollTop
    });
  },
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      showAll: action.payload.showAll,
      searchResult: newSearchResult
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.UPDATE_FILE]: (state, action) => {
    let newSearchResult = [];
    state.searchResult[state.searchResult.indexOf(action.payload.data)] = _objectSpread(_objectSpread({}, action.payload.data), {}, {
      fileNm: action.payload.fileInfo.fileNm,
      fileNote: action.payload.fileInfo.note,
      fileUpdDt: action.payload.fileInfo.updDt
    });
    JSON.parse(JSON.stringify(state.searchResult)).forEach(item => {
      newSearchResult.push(item);
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult
    });
  },
  // 訓練中期計画登録用
  [TYPES.SET_MEDPLAN_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_MEDPLAN_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread({}, action.payload.entries)
    });
  },
  [TYPES.SET_MEDPLAN_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      medplanErrMsg: _objectSpread(_objectSpread({}, state.medplanErrMsg), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.RESET_MEDPLAN_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      medplanErrMsg: INIT_STATE.medplanErrMsg
    });
  },
  // 実施要領・シナリオ登録用
  [TYPES.SET_GUIDANCE_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      guidanceEntry: _objectSpread(_objectSpread({}, state.guidanceEntry), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_GUIDANCE_ENTRIES]: (state, action) => {
    const guidanceEntry = action.payload.guidanceEntry;
    const checkStatusList = Array.from(action.payload.guidanceEntry.checkStatusList);
    return _objectSpread(_objectSpread({}, state), {}, {
      previousGuidanceEntry: _objectSpread(_objectSpread(_objectSpread({}, state.guidanceEntry), guidanceEntry), {}, {
        checkStatusList: checkStatusList,
        regNecScenarioCheck: false,
        regBuScenarioCheck: false
      }),
      guidanceEntry: _objectSpread(_objectSpread(_objectSpread({}, state.guidanceEntry), guidanceEntry), {}, {
        regNecScenarioCheck: false,
        regBuScenarioCheck: false
      })
    });
  },
  [TYPES.CHANGE_SCENARIO]: (state, action) => {
    const guidanceEntry = action.payload.guidanceEntry;
    return _objectSpread(_objectSpread({}, state), {}, {
      guidanceEntry: _objectSpread(_objectSpread({}, state.guidanceEntry), {}, {
        riskDetailNotes: guidanceEntry.riskDetailNotes,
        kunrenPurpose: guidanceEntry.kunrenPurpose,
        kunrenContent: guidanceEntry.kunrenContent,
        checkStatusList: guidanceEntry.checkStatusList
      })
    });
  },
  [TYPES.SET_GUIDANCE_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      guidanceErrMsg: _objectSpread(_objectSpread({}, state.guidanceErrMsg), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.RESET_GUIDANCE_ERR_MSG]: state => {
    return _objectSpread(_objectSpread({}, state), {}, {
      guidanceErrMsg: INIT_STATE.guidanceErrMsg
    });
  },
  // 訓練実施報告用
  [TYPES.SET_REPORT_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      reportEntry: _objectSpread(_objectSpread({}, state.reportEntry), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.SET_REPORT_ENTRIES]: (state, action) => {
    const reportEntry = action.payload.reportEntry;
    const checkStatusList = [];
    const repTaskList = [];
    const reportResultList = [];
    reportEntry.checkStatusList && reportEntry.checkStatusList.forEach(item => {
      checkStatusList.push({
        groupId: item.groupId ? item.groupId : '',
        checkKbn: item.checkKbn ? item.checkKbn : '',
        guidelineCd: item.guidelineCd ? item.guidelineCd : '',
        contents: item.contents ? item.contents : '',
        activityFlg: item.activityFlg ? item.activityFlg : '0',
        notes: item.notes ? item.notes : ''
      });
    });
    reportEntry.repTaskList && reportEntry.repTaskList.forEach(item => {
      repTaskList.push({
        taskNo: item.taskNo ? item.taskNo : '',
        taskCd: item.taskCd ? item.taskCd : '',
        schedule: item.schedule ? item.schedule : '',
        task: item.task ? item.task : '',
        bumon: item.bumon ? item.bumon : '',
        kind: item.kind ? item.kind : '',
        taio: item.taio ? item.taio : '',
        bumonList: !item.bumonList || item.bumonList.length === 0 ? [] : item.bumonList,
        kindList: !item.kindList || item.kindList.length === 0 ? [] : item.kindList,
        taioList: !item.taioList || item.taioList.length === 0 ? [] : item.taioList
      });
    });
    reportEntry.reportResultList && reportEntry.reportResultList.forEach(item => {
      reportResultList.push({
        resultNo: item.resultNo,
        teamName: item.teamName ? item.teamName : '',
        replyNum: item.replyNum ? item.replyNum : '',
        understand: item.understand ? item.understand.toString() : '',
        effect: item.effect ? item.effect.toString() : '',
        teamComment: item.teamComment ? item.teamComment : ''
      });
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      reportEntry: {
        documentKindCd: reportEntry.documentKindCd ? reportEntry.documentKindCd : '',
        scenarioPolicyCd: reportEntry.scenarioPolicyCd ? reportEntry.scenarioPolicyCd : '',
        exercisesDt: reportEntry.exercisesDt ? reportEntry.exercisesDt : '',
        riskDetailNotes: reportEntry.riskDetailNotes ? reportEntry.riskDetailNotes : '',
        kunrenPurpose: reportEntry.kunrenPurpose ? reportEntry.kunrenPurpose : '',
        kunrenContent: reportEntry.kunrenContent ? reportEntry.kunrenContent : '',
        supplement: reportEntry.supplement ? reportEntry.supplement : '',
        partcipant: reportEntry.partcipant ? reportEntry.partcipant : '',
        kunrenResult: reportEntry.kunrenResult ? reportEntry.kunrenResult : '',
        kunrenEvaluation: reportEntry.kunrenEvaluation ? reportEntry.kunrenEvaluation : '',
        hqComments: reportEntry.hqComments ? reportEntry.hqComments : '',
        checkStatusList: checkStatusList,
        fileList: reportEntry.fileList,
        repTaskList: repTaskList,
        reportResultList: reportResultList,
        reportResultAverage: {
          resultNo: 0,
          teamName: '',
          replyNum: '',
          understand: reportEntry.reportResultAverage.understand === 0 ? '' : reportEntry.reportResultAverage.understand.toFixed(2),
          effect: reportEntry.reportResultAverage.effect === 0 ? '' : reportEntry.reportResultAverage.effect.toFixed(2),
          teamComment: ''
        },
        reportResultPrevious: reportEntry.reportResultPrevious ? _objectSpread(_objectSpread({}, reportEntry.reportResultPrevious), {}, {
          understand: reportEntry.reportResultPrevious.understand === 0 ? '' : reportEntry.reportResultPrevious.understand.toFixed(2),
          effect: reportEntry.reportResultPrevious.effect === 0 ? '' : reportEntry.reportResultPrevious.effect.toFixed(2)
        }) : {
          resultNo: 0,
          teamName: '',
          replyNum: '',
          understand: '',
          effect: '',
          teamComment: ''
        },
        krPrgCd: reportEntry.krPrgCd ? reportEntry.krPrgCd : ''
      }
    });
  },
  [TYPES.SET_PREVIOUS_REPORT_ENTRIES]: (state, action) => {
    const previousReportEntry = JSON.parse(JSON.stringify(action.payload.previousReportEntry));
    const repTaskList = [];
    const reportResultList = [];
    previousReportEntry.repTaskList.forEach(item => {
      if (item.bumon || item.kind || item.taio || item.schedule || item.task) {
        repTaskList.push(item);
      }
    });
    previousReportEntry.reportResultList.forEach(item => {
      if (item.teamName || item.replyNum || item.understand || item.effect || item.teamComment) {
        reportResultList.push(item);
      }
    });
    const newEntry = _objectSpread(_objectSpread({}, previousReportEntry), {}, {
      repTaskList: repTaskList,
      reportResultList: reportResultList
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      previousReportEntry: newEntry
    });
  },
  [TYPES.SET_REPORT_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      reportErrMsg: _objectSpread(_objectSpread({}, state.reportErrMsg), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.RESET_REPORT_ERR_MSG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      reportErrMsg: INIT_STATE.reportErrMsg
    });
  },
  // 共通使用
  [TYPES.GO_MAIN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      doSearch: action.payload.doSearch,
      dispContent: CONTENTS.MAIN
    });
  },
  [TYPES.GO_REGISTER]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kunrenInfo: action.payload.kunrenInfo,
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);